import React from "react";
import { useDispatch, useSelector } from "react-redux";
import module_style from "../Style.module.css";
import style from "../../../../../../../Style.module.css";
import {
  EXLY_WEBPAGE_DETAILS__SET_SAVE_CTA,
  EXLY_WEBPAGE_DETAILS__REFETCH_LISTINGS,
} from "ui/pages/TemplatePreview/redux/actions";
import { is_empty } from "utils/validations";
import { WebpageCreationContext } from "ui/pages/TemplatePreview";
import dataProvider from "data/dataProvider";
import api from "data/APIs";
import { is_desktop } from "utils/Utils";

const AddKeywordListing = ({ set_add_keyword_listing }) => {
  const dispatch = useDispatch();

  const listings_data = useSelector((state) => state.webpage_detail.listings);
  const selected_keyword = useSelector(
    (state) => state.webpage_detail.selected_keyword
  );

  const { pushNotif } = React.useContext(WebpageCreationContext);

  React.useEffect(() => {
    dispatch({
      type: EXLY_WEBPAGE_DETAILS__SET_SAVE_CTA,
      save_cta_text: "Add",
      handleSaveCta: handleAdd,
    });
  }, []);

  const [selected_listings, set_selected_listings] = React.useState([]);
  const [selected_plans, set_selected_plans] = React.useState([]);

  const handleAdd = async () => {
    if (is_empty(selected_listings) && is_empty(selected_plans))
      return pushNotif("Select atleast 1");
    if (!is_empty(selected_listings) && !is_empty(selected_plans))
      return pushNotif("Select either listings or plans");
    if (selected_listings.length > 5 || selected_plans.length > 5)
      return pushNotif("Max 5 at a time");

    try {
      const status = await dataProvider.custom_request(
        !is_empty(selected_listings)
          ? api.add_keyword_listing
          : api.add_keyword_plans,
        "POST",
        {
          keyword_uuid: selected_keyword.uuid,
          entity_uuid: !is_empty(selected_listings)
            ? selected_listings
            : selected_plans,
        }
      );
      if (status.status === 200) {
        dispatch({ type: EXLY_WEBPAGE_DETAILS__REFETCH_LISTINGS });
        pushNotif(status.message);
        set_add_keyword_listing(false);
      }
    } catch (err) {
      console.log("handleAdd err", err);
      pushNotif(
        err?.body?.message ? err?.body?.message : "Something went wrong"
      );
    }
  };

  return (
    <div className={`${module_style.container}`}>
      <div className={`${module_style.sub_heading} mb-2`}>
        Assign listings/plans in {selected_keyword?.keyword}.
      </div>

      {!is_empty(
        listings_data.listings_data?.listings?.filter((listing) =>
          is_empty(listing.keywords)
        )
      ) && (
        <div className={`mt-4`}>
          Listings
          {listings_data.listings_data?.listings
            ?.filter((listing) => is_empty(listing.keywords))
            .map((item, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <div key={index} className={`${module_style.card} mt-2`}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div className={``}>
                    <img
                      src={
                        item.side_image
                          ? item.side_image
                          : "https://www.solidbackgrounds.com/images/2560x1440/2560x1440-davys-grey-solid-color-background.jpg"
                      }
                      className={`${module_style.keyword_listing_image}`}
                      alt={`side_image_${index}`}
                    />
                  </div>
                  <div style={{ width: "60%" }} className={`ml-3 mr-3`}>
                    <div className={`${module_style.sub_heading} line_max_2`}>
                      {item.heading}
                    </div>
                    <div
                      className={`${module_style.sub_heading} line_max_1 action_text`}
                    >
                      {item.desc}
                    </div>
                    <input
                      onChange={(e) => {
                        const checked = e.target.checked;
                        let temp = selected_listings;
                        if (checked) {
                          temp.push(item.listing_id);
                        } else if (temp.includes(item.listing_id)) {
                          temp.splice(temp.indexOf(item.listing_id), 1);
                        }
                        set_selected_listings(temp);
                      }}
                      type="checkbox"
                      className={`${module_style.keyword_checkbox} float_right mt-2`}
                    />
                  </div>
                </div>
              </div>
            ))}
        </div>
      )}

      {!is_empty(
        listings_data.plans_data?.plans?.filter((plan) => is_empty(plan.tag))
      ) && (
        <div className={`mt-4`}>
          Plans
          {listings_data.plans_data?.plans
            ?.filter((plan) => is_empty(plan.tag))
            .map((item, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <div key={index} className={`${module_style.card} mt-2`}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div className={``}>
                    <img
                      src={
                        item.side_image
                          ? item.side_image
                          : "https://www.solidbackgrounds.com/images/2560x1440/2560x1440-davys-grey-solid-color-background.jpg"
                      }
                      className={`${module_style.keyword_listing_image}`}
                      alt={`side_image_${index}`}
                    />
                  </div>
                  <div style={{ width: "60%" }} className={`ml-3 mr-3`}>
                    <div className={`${module_style.sub_heading} line_max_2`}>
                      {item.heading}
                    </div>
                    <div
                      className={`${module_style.sub_heading} line_max_1 action_text`}
                    >
                      {item.desc}
                    </div>
                    <input
                      onChange={(e) => {
                        const checked = e.target.checked;
                        let temp = selected_plans;
                        if (checked) {
                          temp.push(item.plan_uuid);
                        } else if (temp.includes(item.plan_uuid)) {
                          temp.splice(temp.indexOf(item.plan_uuid), 1);
                        }
                        set_selected_plans(temp);
                      }}
                      type="checkbox"
                      className={`${module_style.keyword_checkbox} float_right mt-2`}
                    />
                  </div>
                </div>
              </div>
            ))}
        </div>
      )}

      {is_desktop && (
        <div onClick={handleAdd} className={`${style.new_save_cta} mt-3`}>
          Save
        </div>
      )}
    </div>
  );
};

export default AddKeywordListing;
